import { render, staticRenderFns } from "./StudentListProgression.vue?vue&type=template&id=aa6f9416&scoped=true"
import script from "./StudentListProgression.vue?vue&type=script&lang=js"
export * from "./StudentListProgression.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6f9416",
  null
  
)

export default component.exports